export var hexToRgb = function hexToRgb(e) {
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {
    r: parseInt(t[1], 16),
    g: parseInt(t[2], 16),
    b: parseInt(t[3], 16)
  } : null;
};

var componentToHex = function componentToHex(e) {
  var t = e.toString(16);
  return 1 === t.length ? "0" + t : t;
};

export var rgbToHex = function rgbToHex(e, t, n) {
  return "#".concat(componentToHex(e)).concat(componentToHex(t)).concat(componentToHex(n));
};
export var sha256 = function sha256(e) {
  return window.crypto.subtle.digest("SHA-256", new TextEncoder("utf-8").encode(e)).then(function (e) {
    return Array.prototype.map.call(new Uint8Array(e), function (e) {
      return ("00" + e.toString(16)).slice(-2);
    }).join("");
  });
};
export var generateKey = function generateKey() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  return Math.random().toString(16).substr(2, e);
};
export var handleAccessibleKeyPress = function handleAccessibleKeyPress(e, t) {
  "click" !== e.type && "Enter" !== e.key && " " !== e.key && "Spacebar" !== e.key || t();
};